export const navigationCs = {
  'Inbox': 'Schránka',
  'Leads': 'Leady',
  'Tasks': 'Úkoly',
  'Approvals': 'Schvalování',
  'Posts': 'Příspěvky',
  'Reports': 'Reporty',
  'Calendar': 'Kalendář',
  'Audit': 'Audit',
  'Admin': 'Administrace',
  'Sign out': 'Odhlásit se',
  'Open product guide': 'Otevřít průvodce produktem',
};
